module.exports = __webpack_public_path__ + "img/agentstudio-3.1190ddaf.jpg";